var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11652",
    "data-name": "Group 11652",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-external-link",
    "data-name": "Icon open-external-link",
    d: "M0,0V16H16V12H14v2H2V2H4V0Z",
    transform: "translate(13 13)",
    fill: "#54b3be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-external-link-2",
    "data-name": "Icon open-external-link",
    d: "M14,10,11,7l5-5L14,0,9,5,6,2v8Z",
    transform: "translate(13 13)",
    fill: "#54b3be"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbound);
export default __webpack_public_path__ + "static/media/inbound.458b912cff044b861b46d0338c460989.svg";
export { ForwardRef as ReactComponent };